"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageInput = exports.imageAggregate = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const utils_1 = require("@obvio/utils");
const browser_image_compression_1 = __importDefault(require("browser-image-compression"));
const react_1 = require("react");
const FileInput_1 = require("./FileInput");
const FileInfo_1 = require("./FileInput/FileInfo");
const components_1 = require("./ImageInput/components");
const utils_2 = require("./utils");
const AggregateData_1 = require("../AggregateData");
function getRatiosMap(assets) {
    return assets.reduce((acc, img) => Object.assign(acc, { [img.name]: img.ratio }), {});
}
function ImgInputElem(_a) {
    var { files, processing, removeFile, maxFiles = Infinity, maxSize = Infinity, setFiles } = _a, props = __rest(_a, ["files", "processing", "removeFile", "maxFiles", "maxSize", "setFiles"]);
    const [dataUrls, setUrls] = (0, react_1.useState)({});
    const loadedNames = (0, react_1.useRef)(new Set());
    (0, react_1.useEffect)(() => {
        function setUrlsFromFiles() {
            return __awaiter(this, void 0, void 0, function* () {
                for (const file of files) {
                    const { name } = file;
                    if (!loadedNames.current.has(name)) {
                        loadedNames.current.add(name);
                        if (file instanceof Blob) {
                            const data = yield browser_image_compression_1.default.getDataUrlFromFile(file);
                            setUrls((current) => (Object.assign(Object.assign({}, current), { [name]: data })));
                        }
                        else {
                            const { src } = file;
                            setUrls((current) => (Object.assign(Object.assign({}, current), { [name]: src })));
                        }
                    }
                }
            });
        }
        void setUrlsFromFiles();
    }, [files]);
    return ((0, jsx_runtime_1.jsx)(utils_2.DefaultDropzone, Object.assign({ maxFiles: maxFiles, maxSize: maxSize, files: files, processing: processing, setFiles: setFiles, fileRenderer: ({ file, dragHandleProps }) => ((0, jsx_runtime_1.jsx)(components_1.Image, { img: file, src: dataUrls[file.name], onRemove: () => removeFile(file), dragHandleProps: dragHandleProps, sizes: "700px" })) }, props)));
}
const compressFile = (file, width, height) => __awaiter(void 0, void 0, void 0, function* () {
    let compressedFile = file;
    if (Math.max(width, height) > 4096) {
        compressedFile = yield (0, browser_image_compression_1.default)(compressedFile, { maxWidthOrHeight: 4096 });
    }
    if (file.size > (0, utils_1.bytes)(1, 'M')) {
        compressedFile = yield (0, browser_image_compression_1.default)(compressedFile, { maxSizeMB: 1 });
    }
    return compressedFile;
});
const imageAggregate = (id, ratios, dataUrl) => (data) => {
    var _a, _b;
    return (_b = (_a = data === null || data === void 0 ? void 0 : data[id]) === null || _a === void 0 ? void 0 : _a.map((file) => ({
        file,
        urlData: dataUrl[file.name],
        ratio: ratios[file.name],
        thumb: 'thumb' in file ? file === null || file === void 0 ? void 0 : file.thumb : undefined,
    }))) !== null && _b !== void 0 ? _b : [];
};
exports.imageAggregate = imageAggregate;
function ImageInput(_a) {
    var _b;
    var { showLayoutOptions, name, maxFiles, optional, defaultValue, keepRegistered } = _a, inputProps = __rest(_a, ["showLayoutOptions", "name", "maxFiles", "optional", "defaultValue", "keepRegistered"]);
    const dataUrls = (0, react_1.useRef)({});
    const id = (0, react_1.useMemo)(() => `${name}-imgInput`, [name]);
    const ratios = (0, react_1.useRef)(getRatiosMap(defaultValue !== null && defaultValue !== void 0 ? defaultValue : []));
    const processFile = (0, react_1.useCallback)((file) => __awaiter(this, void 0, void 0, function* () {
        const { width, height } = yield loadImage(file);
        const compressedFile = yield compressFile(file, width, height);
        const dataURL = yield browser_image_compression_1.default.getDataUrlFromFile(compressedFile);
        dataUrls.current[compressedFile.name] = dataURL;
        ratios.current[compressedFile.name] = (0, utils_1.round)(width / height, 2);
        return compressedFile;
    }), []);
    const renderProps = (0, react_1.useMemo)(() => ({
        maxFiles,
        maxSize: 1048576 * 5,
    }), [maxFiles]);
    const agg = (0, react_1.useMemo)(() => (0, exports.imageAggregate)(id, ratios.current, dataUrls.current), [id, ratios]);
    return ((0, jsx_runtime_1.jsx)(AggregateData_1.AggregateData, Object.assign({ name: name, aggregate: agg, keepRegistered: keepRegistered }, { children: (0, jsx_runtime_1.jsx)(FileInput_1.FileInput, Object.assign({ name: id, accept: {
                'image/*': ['.jpg', '.jpeg', '.png', '.webp', '.svg'],
            }, defaultValue: (_b = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.map((v) => { var _a; return (_a = v.file) !== null && _a !== void 0 ? _a : v; })) !== null && _b !== void 0 ? _b : [], info: (props) => (0, jsx_runtime_1.jsx)(FileInfo_1.FileInfo, Object.assign({}, props, { image: true })), processFile: processFile, render: ImgInputElem, renderProps: renderProps, optional: Boolean(optional) }, inputProps)) })));
}
exports.ImageInput = ImageInput;
function loadImage(file) {
    return __awaiter(this, void 0, void 0, function* () {
        return browser_image_compression_1.default.loadImage(yield browser_image_compression_1.default.getDataUrlFromFile(file));
    });
}
